/**
 * Autogenerated file don't modify
 */
(function () {
(function () {
    'use strict';

    MoyaEventHandler.on('store.recentlyViewedProducts.create', function (data) {
        data.card.classList.add('storeCard--product');
        data.card.classList.add('v1');
        data.card.querySelector('a').remove();
        var price = createLabel(data.item.lastPrice);
        var title = createTitle(data.item.title, data.item.url);
        var wrap = document.createElement('div');
        wrap.classList.add('wrap');
        wrap.appendChild(title);
        wrap.appendChild(price);
        data.card.appendChild(wrap);
        function createLabel(lastPrice) {
            var value = document.createElement('div');
            value.classList.add('value');
            var priceDiff = document.createElement('div');
            priceDiff.classList.add('priceDiff');
            var priceSpan = document.createElement('span');
            priceSpan.classList.add('price');
            var priceNumber = document.createElement('span');
            priceNumber.classList.add('n');
            priceNumber.innerText = lastPrice;
            var priceCurrency = document.createElement('span');
            priceCurrency.classList.add('c');
            priceCurrency.classList.add('s');
            priceCurrency.innerText = ' kr.';
            priceSpan.appendChild(priceNumber);
            priceSpan.appendChild(priceCurrency);
            priceDiff.appendChild(priceSpan);
            value.appendChild(priceDiff);
            var priceLabel = document.createElement('span');
            priceLabel.classList.add('priceLabel');
            priceLabel.innerText = 'Verð';
            var labels = document.createElement('div');
            labels.classList.add('labels');
            labels.appendChild(priceLabel);
            var storePrice = document.createElement('div');
            storePrice.classList.add('storePrice');
            storePrice.appendChild(labels);
            storePrice.appendChild(value);
            return storePrice;
        }
        function createTitle(title, url) {
            var span = document.createElement('span');
            span.innerText = title;
            var link = document.createElement('a');
            link.href = url;
            link.appendChild(span);
            var heading = document.createElement('h2');
            heading.classList.add('title');
            heading.appendChild(link);
            return heading;
        }
    });

}());
typeof tsBuild === 'function' && tsBuild();})();
